<template>
  <div class="buttom">&nbsp;&nbsp;&nbsp;&nbsp;重庆乾端科技有限公司</div>
</template>

<script>
export default {
  name: "AppButtom",
};
</script>

<style scoped>
.buttom {
  color: white;
  text-align: center;
}
</style>